const Header = () => {
  return (
    <header className='flex justify-start px-8 py-6'>
      <img className='h-7' src='https://cdn.eduzzcdn.com/topbar/eduzz-colored.svg' alt='Logo' />
    </header>
  );
};

export default Header;
